import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { startServiceWorkerUpdateChecks } from './shared/pwa/checkForUpdates.js'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element #root not found')
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Keep an installed/kept-open PWA from running a stale bundle after a deploy —
// re-check for a new service worker on focus + a slow timer. See the helper.
startServiceWorkerUpdateChecks()
